import { Currency } from '@/common/domain/token/Currency';

export interface Fiat {
  value: number;
  currency: Currency;
}

export const euro = (value: number): Fiat => ({ value, currency: Currency.EURO });
